import { render, staticRenderFns } from "./MediumList.vue?vue&type=template&id=5e22d7fb&scoped=true"
import script from "./MediumList.vue?vue&type=script&lang=ts"
export * from "./MediumList.vue?vue&type=script&lang=ts"
import style0 from "./MediumList.vue?vue&type=style&index=0&id=5e22d7fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e22d7fb",
  null
  
)

export default component.exports